import MANAGE_CUSTOMERS from "../actionTypes/manageCustomers";

const initialState = {
  customerData: [],
};

const manageCustomers = (state = initialState, action) => {
  switch (action.type) {
    case MANAGE_CUSTOMERS.GET_CUSTOMERS:
      return { ...state, customerData: action.payload };
    default:
      return state;
  }
};

export default manageCustomers;
